import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Search, MoonStar } from 'lucide-react';
const stats = [{
  Icon: Clock,
  value: '120+',
  unit: 'horas al año',
  label: 'perdidas',
  desc: 'Tiempo que ya no recuperás de tu vida personal y familiar.'
}, {
  Icon: Search,
  value: '∞',
  unit: 'horas',
  label: 'buscando actividades',
  desc: 'Pinterest, Drive, Whatsapp de colegas, libros viejos... y nada cierra.'
}, {
  Icon: MoonStar,
  value: '52',
  unit: 'domingos',
  label: 'planificando',
  desc: 'Noches y fines de semana enteros armando consignas a último momento.'
}];
export function HiddenCost() {
  return <section className="py-20 lg:py-24 bg-ink-50" data-id="element-115">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-117">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-ink-700 font-bold text-xs uppercase tracking-wider mb-5 border border-ink-100 shadow-soft" data-id="element-118">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-500" data-id="element-119"></span>
            Hablemos en serio
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-120">
            El verdadero costo de{' '}
            <span className="text-brand-500" data-id="element-121">improvisar tus clases</span>
          </h2>
          <p className="text-lg text-ink-600" data-id="element-122">
            No es solo cansancio. Es tiempo de tu vida que no vuelve.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-123">
          {stats.map((s, i) => {
          const Icon = s.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="group bg-white rounded-3xl p-8 shadow-soft border border-ink-100 hover:shadow-card hover:-translate-y-1 transition-all" data-id="element-124">
                <div className="w-14 h-14 rounded-2xl bg-ink-900 text-brand-500 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-125">
                  <Icon className="w-7 h-7" data-id="element-126" />
                </div>
                <div className="flex items-baseline gap-2 mb-2" data-id="element-127">
                  <span className="text-5xl md:text-6xl font-black text-brand-500 leading-none tracking-tight" data-id="element-128">
                    {s.value}
                  </span>
                  <span className="text-sm font-bold text-ink-500 uppercase tracking-wider" data-id="element-129">
                    {s.unit}
                  </span>
                </div>
                <div className="text-lg font-bold text-ink-900 mb-3" data-id="element-130">
                  {s.label}
                </div>
                <p className="text-ink-600 leading-relaxed text-sm" data-id="element-131">{s.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}